import { render } from "./ItemModalButton.vue?vue&type=template&id=d161c1da&scoped=true"
import script from "./ItemModalButton.vue?vue&type=script&lang=js"
export * from "./ItemModalButton.vue?vue&type=script&lang=js"

import "./ItemModalButton.vue?vue&type=style&index=0&id=d161c1da&lang=scss&scoped=true"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d161c1da"]])

export default __exports__